import { EnumOption } from "./enum-option"

export const CompanyType = {
    Employer: 0,
    EmploymentSponsorship: 1,   
}

export const CompanyTypeList: EnumOption[] = [
    { value: CompanyType.Employer, label: 'Employer' },
    { value: CompanyType.EmploymentSponsorship, label: 'Employment Sponsorship' },   
]
